{
  "version": 1,
  "asset_id": "a77112f4-6602-46f6-a8ca-aa8212266726",
  "project_id": "f7b0049a-604b-4310-83a1-b58bfd5bd64c",
  "url": "/__l5e/assets-v1/a77112f4-6602-46f6-a8ca-aa8212266726/verqo-logo.png",
  "r2_key": "a/v1/f7b0049a-604b-4310-83a1-b58bfd5bd64c/a77112f4-6602-46f6-a8ca-aa8212266726/verqo-logo.png",
  "original_filename": "verqo-logo.png",
  "size": 1275852,
  "content_type": "image/png",
  "created_at": "2026-07-11T09:28:24Z"
}
